import { Box, Typography } from '@mui/material';
import React from 'react';
import DefaultModal from '../../components/Modals/DefaultModal';

interface ModalProps {
  open: boolean;
  setOpen: (e: boolean) => void;
}

export default function LoadingFilesModal(props: ModalProps): JSX.Element {
  return (
    <DefaultModal open={props.open} handleClose={() => props.setOpen(false)}>
      <Box sx={{ px: 6, pb: 4 }}>
        <Typography variant="h4" textAlign="center" color="grey.900" mb={2}>
          Loading
        </Typography>
        We are loading the file, this can take some time, please wait.
      </Box>
    </DefaultModal>
  );
}
